var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      attrs: {
        id: "my_seminars",
      },
    },
    _vm._l(_vm.groups, function (group) {
      return _c(
        "table",
        {
          key: group.id,
          staticClass: "default collapsable mycourses",
        },
        [
          _c("caption", [_vm._v(" " + _vm._s(group.name))]),
          _vm._v(" "),
          _c("colgroup", [
            _c("col", {
              staticStyle: {
                width: "7px",
              },
            }),
            _vm._v(" "),
            _c("col", {
              staticStyle: {
                width: "25px",
              },
            }),
            _vm._v(" "),
            _vm.getConfig("sem_number") && !_vm.responsiveDisplay
              ? _c("col", {
                  staticStyle: {
                    width: "70px",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("col"),
            _vm._v(" "),
            !_vm.responsiveDisplay
              ? _c("col", {
                  style: {
                    width:
                      2 * 5 +
                      _vm.numberOfNavElements * (_vm.iconSize + 2 * 3 + 3) -
                      3 +
                      "px",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.responsiveDisplay
              ? _c("col", {
                  staticStyle: {
                    width: "24px",
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("thead", [
            _c(
              "tr",
              {
                staticClass: "sortable",
              },
              [
                _c("th", [
                  _c(
                    "span",
                    {
                      staticClass: "sr-only",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$gettext("Zugeordnete Farbgruppe")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("th"),
                _vm._v(" "),
                _vm.getConfig("sem_number") && !_vm.responsiveDisplay
                  ? _c(
                      "th",
                      {
                        class: _vm.getOrderClasses("number"),
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#",
                            },
                            on: {
                              click: function click($event) {
                                $event.preventDefault()
                                return _vm.changeOrder("number")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$gettext("Nr.")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    class: _vm.getOrderClasses("name"),
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.changeOrder("name")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$gettext("Name")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.responsiveDisplay
                  ? _c("th", [_vm._v(_vm._s(_vm.$gettext("Inhalt")))])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.responsiveDisplay ? _c("th") : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._l(group.data, function (subgroup) {
            return _c(
              "tbody",
              {
                key: subgroup.id,
                class: {
                  collapsed: !_vm.isGroupOpen(subgroup),
                },
              },
              [
                subgroup.label !== false
                  ? _c(
                      "tr",
                      {
                        staticClass: "header-row",
                      },
                      [
                        _c("th", {
                          staticStyle: {
                            "white-space": "nowrap",
                            "text-align": "left",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "toggle-indicator",
                            attrs: {
                              colspan:
                                _vm.getConfig("sem_number") &&
                                !_vm.responsiveDisplay
                                  ? 3
                                  : 2,
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "#",
                                },
                                on: {
                                  click: function click($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.toggleOpenGroup(subgroup)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(subgroup.label))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.responsiveDisplay
                          ? _c("th", {
                              staticClass: "dont-hide",
                              attrs: {
                                colspan: "2",
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.getOrderedCourses(subgroup.ids), function (course) {
                  return _c(
                    "tr",
                    {
                      key: course.id,
                      class: _vm.getCourseClasses(course),
                      attrs: {
                        "data-course-id": course.id,
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          class: "gruppe".concat(course.group),
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "sr-only",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Diese Veranstaltung gehört zur Farbgruppe %{group}"
                                      ),
                                      course
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "subcourse-indented": _vm.isChild(course),
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "my-courses-avatar course-avatar-small",
                            style: {
                              backgroundImage: "url(".concat(course.avatar),
                            },
                            attrs: {
                              title: course.name,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.getConfig("sem_number") && !_vm.responsiveDisplay
                        ? _c(
                            "td",
                            {
                              class: {
                                "subcourse-indented": _vm.isChild(course),
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(course.number) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "subcourse-indented": _vm.isChild(course),
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.urlFor("seminar_main.php", {
                                  auswahl: course.id,
                                }),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getCourseName(
                                      course,
                                      _vm.getConfig("sem_number") &&
                                        _vm.responsiveDisplay
                                    )
                                  ) +
                                  "\n                        "
                              ),
                              course.is_deputy
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$gettext("[Vertretung]"))
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          course.is_hidden
                            ? _c(
                                "span",
                                {
                                  staticClass: "course-hidden-info",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("[versteckt]")) +
                                      "\n                        "
                                  ),
                                  _c("studip-tooltip-icon", {
                                    attrs: {
                                      text: _vm.getHiddenTooltip(course),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.responsiveDisplay
                            ? _c(
                                "div",
                                {
                                  staticClass: "mycourse_elements",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "special_nav",
                                    },
                                    [
                                      _c("studip-action-menu", {
                                        attrs: {
                                          items:
                                            _vm.getActionMenuForCourse(course),
                                          collapseAt: false,
                                        },
                                        on: {
                                          "show-color-picker":
                                            function showColorPicker($event) {
                                              _vm.shownColorPicker = course.id
                                            },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("my-courses-navigation", {
                                    attrs: {
                                      navigation:
                                        _vm.getNavigationForCourse(course),
                                      "icon-size": _vm.iconSize,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.responsiveDisplay
                        ? _c(
                            "td",
                            {
                              staticClass: "course-navigation",
                            },
                            [
                              _c("my-courses-navigation", {
                                attrs: {
                                  navigation: _vm.getNavigationForCourse(
                                    course,
                                    true
                                  ),
                                  "icon-size": _vm.iconSize,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.responsiveDisplay
                        ? _c(
                            "td",
                            {
                              staticClass: "actions",
                            },
                            [
                              _c("studip-action-menu", {
                                attrs: {
                                  items: _vm.getActionMenuForCourse(course),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            )
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }